import { Coins } from "lucide-react";
import { Badge, Skeleton } from "@aurelia/ui";
import { useWallet } from "../../features/wallet/queries";
import { useDocumentMeta } from "../../lib/useDocumentMeta";

export function WalletPage() {
  useDocumentMeta("My Wallet", "Your reward coin balance and history.", undefined, undefined, { noindex: true });
  const { data: wallet, isLoading } = useWallet();

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <Skeleton className="h-28" />
        <Skeleton className="h-40" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-8">
      <div className="rounded-2xl border border-border bg-surface-raised p-6 flex items-center gap-4">
        <div className="h-14 w-14 rounded-full bg-accent-soft text-accent-strong flex items-center justify-center shrink-0">
          <Coins size={24} />
        </div>
        <div>
          <p className="text-sm text-ink-muted">Your coin balance</p>
          <p className="text-3xl font-semibold tracking-tight">{wallet?.balance ?? 0} coins</p>
          <p className="text-xs text-ink-muted mt-1">Worth Rs {wallet?.balance ?? 0} — 1 coin = Rs 1 off your next order</p>
        </div>
      </div>

      <div>
        <h2 className="text-sm font-semibold text-ink-muted uppercase tracking-wide mb-4">History</h2>
        {!wallet || wallet.ledger.length === 0 ? (
          <p className="text-ink-muted text-sm">No coin activity yet. Earn coins by buying eligible products.</p>
        ) : (
          <div className="flex flex-col gap-3">
            {wallet.ledger.map((entry) => (
              <div
                key={entry.id}
                className="flex items-center justify-between rounded-xl border border-border bg-surface px-4 py-3"
              >
                <div className="flex items-center gap-3">
                  <Badge tone={entry.type === "SPENT" ? "neutral" : "success"}>
                    {entry.type === "EARNED" ? "Earned" : entry.type === "REFUNDED" ? "Refunded" : "Spent"}
                  </Badge>
                  <div>
                    <p className="text-sm">
                      {entry.note ??
                        (entry.type === "EARNED" ? "Coins earned" : entry.type === "REFUNDED" ? "Coins refunded" : "Coins spent")}
                    </p>
                    <p className="text-xs text-ink-muted">{new Date(entry.createdAt).toLocaleDateString()}</p>
                  </div>
                </div>
                <span className={`text-sm font-medium ${entry.amount > 0 ? "text-emerald-600 dark:text-emerald-400" : "text-ink"}`}>
                  {entry.amount > 0 ? "+" : ""}
                  {entry.amount}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
